import React, { useState } from 'react';
import { Box, Typography, useTheme, useMediaQuery } from '@mui/material';
import { Icon } from '@iconify/react';
import TopBar from '../components/TopBar';
import Sidebar from '../components/Sidebar';
import CheckerAmendmentTable from '../components/CheckerAmendmentTable';
interface CheckerInboxAmendmentProps {
  onLogout: () => void;
}
const CheckerInboxAmendment: React.FC<CheckerInboxAmendmentProps> = ({
  onLogout
}) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  return <Box sx={{
    display: 'flex',
    width: '100%',
    minHeight: '100vh',
    backgroundColor: '#F8FAFC',
    overflow: 'hidden'
  }} data-id="element-2705">
      <TopBar onMenuClick={handleDrawerToggle} onLogout={onLogout} title="Checker Inbox - Amendments" data-id="element-2706" />
      <Sidebar open={mobileOpen} onClose={handleDrawerToggle} activePage="checker-inbox-amendment" data-id="element-2707" />
      <Box component="main" sx={{
      flexGrow: 1,
      py: 2,
      px: 1,
      width: {
        xs: '100%',
        sm: `calc(100% - 240px)`
      },
      maxWidth: '100%',
      ml: {
        xs: 0,
        sm: '240px'
      },
      mt: 8,
      overflow: 'hidden'
    }} data-id="element-2708">
        <Box sx={{
        maxWidth: '100%'
      }} data-id="element-2709">
          <Box sx={{
          display: 'flex',
          alignItems: 'center',
          mb: 2
        }} data-id="element-2710">
            <Icon icon="lucide:clipboard-edit" width={28} height={28} color="#0EA5E9" data-id="element-2711" />
            <Typography variant="h5" component="h1" sx={{
            ml: 1.5,
            fontWeight: 600
          }} data-id="element-2712">
              Checker Inbox - Amendments
            </Typography>
          </Box>
          <CheckerAmendmentTable data-id="element-2713" />
        </Box>
      </Box>
    </Box>;
};
export default CheckerInboxAmendment;